let disabled_form_button = function( $ ) {

	let $forms;

	let _init = function() {
		$forms = $( 'form.button-disabled' ).not( '.setup-disabled-button-check' );

		if ( $forms.length > 0 ) {
			$forms.each( ( index, item ) => {
				setup_form( $( item ) );
			} )
		}
	};

	let setup_form = function( $form, $submit_elem = false ) {
		if ( $form.hasClass( 'setup-disabled-button-check' ) ) {
			return;
		}

		$form.addClass( 'setup-disabled-button-check' );

		if ( ! $submit_elem ) {
			$submit_elem = $form.find( '.submit-button' );
		}

		let excluded_class = $form.data( 'exclude-field-class' ) ? $form.data( 'exclude-field-class' ) : 'exclude-button-check';

		$form.find( 'input, select, textarea' ).not( '.submit-button, .' + excluded_class ).on( 'change', ( e ) => {

			let should_enable_button = false;

			$form.find( 'input, select' ).not( '.submit-button, .' + excluded_class ).each( ( index, item ) => {

				if ( $( item ).val() ) {
					should_enable_button = true;
				}
			} );

			if ( should_enable_button ) {
				$submit_elem.removeClass( 'disabled' );
				$form.trigger( 'enable_button' );
			} else {
				$submit_elem.addClass( 'disabled' );
				$form.trigger( 'disable_button' );
			}
		} );
	};

	$( document ).ready( _init );

	return {
		setup_form: setup_form
	}

} ( jQuery );

module.exports = disabled_form_button;